
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "../Styles/Home.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
// import Settings from "../Components/Profile/Settings.jsx";

function ImageMagnifier({ src, width, height, zoom = 2, magnifierSize = 150 }) {
  const [[x, y], setXY] = useState([0, 0]);
  const [showMagnifier, setShowMagnifier] = useState(false);
  

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        border: "1px solid #eee",
        display:"flex",
        alignItems:"center",
        justifyContent:"center"
      }}
      className="product-detail-img"
    >
      <img
        src={src}
        onMouseEnter={() => setShowMagnifier(true)}
        onMouseLeave={() => setShowMagnifier(false)}
        onMouseMove={(e) => {
          const { top, left } = e.currentTarget.getBoundingClientRect();
          const x = e.pageX - left - window.pageXOffset;
          const y = e.pageY - top - window.pageYOffset;
          setXY([x, y]);
        }}
        alt="Zoom"
        className="product-detail-img"
      />

      {showMagnifier && (
        <div
          style={{
            position: "absolute",
            pointerEvents: "none",
            top: `${y - magnifierSize / 2}px`,
            left: `${x - magnifierSize / 2}px`,
            width: `${magnifierSize}px`,
            height: `${magnifierSize}px`,
            border: "2px solid #ccc",
            borderRadius: "50%",
            backgroundColor: "white",
            backgroundImage: `url('${src}')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: `${parseInt(width) * zoom}px ${parseInt(
              height
            ) * zoom}px`,
            backgroundPositionX: `${-x * zoom + magnifierSize / 2}px`,
            backgroundPositionY: `${-y * zoom + magnifierSize / 2}px`
          }}
        />
      )}
    </div>
  );
}

 function ProductImageGallery({imgs}) {
  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    swipeToSlide: true,
    focusOnSelect: true
  };
console.log("imgs are : ", imgs)
  const [activeImage, setActiveImage] = useState(null);
  const allImages = imgs.map((item)=>(item.real_image_path))
  const [loading, setLoading] = useState(true);

useEffect(() => {
  if (allImages.length > 0 && activeImage) {
    setLoading(false);
  }
}, [allImages, activeImage]);

  

    useEffect(() => {
      if (imgs && imgs.length > 0) {
        const firstImage = imgs[0].real_image_path;
        setActiveImage(firstImage);
      }
    }, [imgs]);
  
    
  


  return (
<div style={{  maxWidth: "100%",padding: 5 }}>
  {loading ? (
    <Skeleton width={500} height={450} />
  ) : (
    <div style={{width:"100%",display:"flex",justifyContent:"center"}}>
    <ImageMagnifier
      src={activeImage}
      width="600px"
      height="490px"
      zoom={2}
      magnifierSize={200}
    />
    </div>
  )}

<div
  style={{
    marginTop: 10,
    overflowX: "auto",
    paddingBottom: "5px",
    borderTop: "1px solid #eee",
    borderBottom: "1px solid #eee",
    marginBottom: "10px",
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "center", // centers all images horizontally
      gap: "10px",
      minWidth: "100%",          // ensures flex children get centered
    }}
  >
    {loading
      ? Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} width={60} height={60} />
        ))
      : allImages.map((img, index) => (
          <img
            key={index}
            src={img}
            onClick={() => setActiveImage(img)}
            style={{
              width: 60,
              height: 60,
              objectFit: "cover",
              borderRadius: "8px",
              cursor: "pointer",
              flexShrink: 0,
              border:
                activeImage === img
                  ? "2px solid blue"
                  : "1px solid #ccc",
            }}
          />
        ))}
  </div>
</div>

</div>

  );
}
export default ProductImageGallery;




























